import React, { useEffect, useState } from "react";

import { handleGetItemsWithParam } from "../../shared/controllers/blogController";
import { unwrapApiArray } from "../../shared/utils/apiResponse";
import LoadingGrid from "../../utils/loadingGrid";
import Banner from "../components/Banner";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import landingAsset from "../utils/assetPaths";

interface EventItem {
    id: string | number;
    title: string;
    description: string;
    image?: string;
    date: string;
}

const Events: React.FC = () => {
    const [events, setEvents] = useState<EventItem[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchEvents = async () => {
            try {
                const params = { type: "Event" };
                const data = await handleGetItemsWithParam<EventItem[]>(params);
                setEvents(unwrapApiArray<EventItem>(data));
            } catch (error) {
                console.error(error);
            } finally {
                setLoading(false);
            }
        };
        fetchEvents();
    }, []);

    return (
        <>
            <Navbar />
            <div
                style={{
                    backgroundImage: `url(${landingAsset("herobg.svg")})`,
                    backgroundSize: "cover",
                }}
                className="h-[500px] md:h-[400px] relative w-full flex justify-center items-center flex-col "
            >
                <div
                    style={{
                        background:
                            "linear-gradient(180deg, rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0) 17.83%)",
                    }}
                    className=" h-full w-full absolute left-0 top-0 text-center flex flex-col items-center justify-center p-4"
                >
                    <h1 className="text-white text-4xl md:text-5xl lg:text-6xl font-black font-Manrope uppercase tracking-tight">SACA Events</h1>
                    <p className=" mt-6 text-center font-Manrope text-lg md:text-xl text-white/90 max-w-2xl leading-relaxed">
                        Join the passion. Discover local tournaments, community gatherings, and international soccer experiences.
                    </p>
                </div>
            </div>

            <div className="py-24 bg-white px-4 md:px-14">
                <div className="max-w-7xl mx-auto">
                    <div className="space-y-4 mb-16">
                        <h3 className="text-green-700 font-black uppercase tracking-[0.2em] text-sm">What's Happening</h3>
                        <h2 className="text-4xl md:text-5xl font-black text-gray-900">Upcoming Experiences</h2>
                    </div>

                    {loading ? (
                        <LoadingGrid count={3} />
                    ) : events.length === 0 ? (
                        <div className="bg-gray-50 p-20 rounded-[48px] text-center border-2 border-dashed border-gray-100 italic font-bold text-gray-400 text-xl">
                            No upcoming events scheduled at this moment.
                        </div>
                    ) : (
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
                            {events.map((event, i) => (
                                <div key={i} className="bg-gray-50 rounded-[48px] overflow-hidden border border-gray-100 group hover:bg-white hover:shadow-2xl transition-all duration-500">
                                    <div className="relative aspect-video overflow-hidden">
                                        <img src={event.image || landingAsset("stadia.svg")} alt="" className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" />
                                        <div className="absolute top-6 left-6 px-5 py-2 bg-white/90 backdrop-blur rounded-2xl font-black text-xs uppercase tracking-widest text-green-700 shadow-xl">
                                            {new Date(event.date).toLocaleDateString('en-US', { day: '2-digit', month: 'short' })}
                                        </div>
                                    </div>
                                    <div className="p-10 space-y-6">
                                        <h3 className="text-2xl font-black text-gray-900 group-hover:text-green-700 transition-colors uppercase tracking-tighter leading-tight">{event.title}</h3>
                                        <p className="text-gray-500 font-medium line-clamp-3 italic leading-relaxed">{event.description}</p>
                                        <div className="pt-4 flex items-center justify-between border-t border-gray-100">
                                            <span className="text-xs font-black text-gray-400 uppercase tracking-widest">SACA COMMUNITY</span>
                                            <span className="text-green-700 font-black uppercase tracking-widest text-xs group-hover:underline underline-offset-4 pointer cursor-pointer">Know More →</span>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>

            <Banner />
            <Footer />
        </>
    );
};

export default Events;
